'use strict';

Object.defineProperty(exports, Symbol.toStringTag, {
  value: 'Module'
});
var trackSize = require('./track-size.js');
var trackSizes = require('./track-sizes.js');
exports.trackElementSize = trackSize.trackElementSize;
exports.trackElementsSize = trackSizes.trackElementsSize;